import React from 'react';

import { openDrawer } from '@element/index'
import { useIsomorphicLayoutEffect } from '@lib/hooks'

import { Main } from './Main'

interface LoginRegisterProps {
  defaultType?: 'login'|'register';
  /** 主题 */
  theme?: Theme;
  /** 登录或注册完成之后的回调 */
  cb?: (params: any) => void;
}

export const LoginRegister: React.FC<LoginRegisterProps> = (props) => {
  useIsomorphicLayoutEffect(() => {
    openDrawer({
      content: ({ close }) => <Main {...props} close={close} />,
      onClose: (close) => {
        return close;
      },
      theme: props.theme
    })
  }, [])

  return null
}
